import { render, staticRenderFns } from "./DashboardTokenStatistic.vue?vue&type=template&id=63760c7f&scoped=true&lang=pug"
import script from "./DashboardTokenStatistic.vue?vue&type=script&lang=ts"
export * from "./DashboardTokenStatistic.vue?vue&type=script&lang=ts"
import style0 from "./DashboardTokenStatistic.vue?vue&type=style&index=0&id=63760c7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63760c7f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VRow})
